<template>
  <div :class="classes">
    <v-menu ref="datepicker" v-model="datepicker" transition="scale-transition" offset-y>
      <template v-slot:activator="{ on, attrs }">
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-text-field
          v-model="date" v-bind="attrs" v-on="on"
          append-icon="mdi-calendar" class="mr-1" solo dense hide-details readonly
          @click:append="on.click"></v-text-field>
      </template>
      <!-- eslint-disable-next-line prettier/prettier -->
      <v-date-picker
        :value="date" color="primary" no-title scrollable
        :day-format="date => new Date(date).getDate()" @change="setDate"
       >
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="setToday">
          Today
        </v-btn>
      </v-date-picker>
    </v-menu>
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-text-field
          v-model="time" v-bind="attrs" v-on="on"
          append-icon="mdi-clock-time-four-outline" class="mr-1" solo dense hide-details readonly
          @click:append="on.click"
        />
      </template>
      <v-list style="max-height: 200px" class="overflow-y-auto" dense>
        <v-list-item-group>
          <v-list-item v-for="(time, index) in timetables" :key="index" @click="setTime(time)" link>
            <v-list-item-title class="time-font">{{ time }}</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
    <div class="toolbox">
      <v-tooltip content-class="tooltip" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="moveBackward(backward[1])" v-bind="attrs" v-on="on" class="mr-1" x-small>
            <v-icon small>
              mdi-skip-backward
            </v-icon>
          </v-btn>
        </template>
        <span>{{ this.$t('components.tn.morePrevious') }}</span>
      </v-tooltip>
      <v-tooltip content-class="tooltip" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="moveBackward(backward[0])" v-bind="attrs" v-on="on" class="mr-1" x-small>
            <v-icon small>
              mdi-skip-previous
            </v-icon>
          </v-btn>
        </template>
        <span>{{ this.$t('components.tn.previous') }}</span>
      </v-tooltip>
      <v-tooltip content-class="tooltip" bottom>
        <template v-slot:activator="{ on, attrs }">
          <!-- <v-btn v-if="increment > 0" @click="toggleAutoIncrement" :color="autoIncrement ? 'primary' : '#5A5A5A'" v-bind="attrs" v-on="on" class="mr-1" x-small> -->
          <v-btn v-if="increment > 0" @click="emitActiveIncrement(!activeIncrement)" :color="activeIncrement ? 'primary' : '#5A5A5A'" v-bind="attrs" v-on="on" class="mr-1" x-small>
            <v-icon small>
              mdi-refresh
            </v-icon>
          </v-btn>
        </template>
        <span>{{ this.$t(`components.tn.${activeIncrement ? 'stop' : 'play'}`) }}</span>
      </v-tooltip>
      <v-tooltip content-class="tooltip" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="moveForward(forward[0])" :disabled="disabledForward" v-bind="attrs" v-on="on" class="mr-1" x-small>
            <v-icon small>
              mdi-skip-next
            </v-icon>
          </v-btn>
        </template>
        <span>{{ this.$t('components.tn.next') }}</span>
      </v-tooltip>
      <v-tooltip content-class="tooltip" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="moveForward(forward[1])" :disabled="disabledFurtherForward" v-bind="attrs" v-on="on" class="mr-1" x-small>
            <v-icon small>
              mdi-skip-forward
            </v-icon>
          </v-btn>
        </template>
        <span>{{ this.$t('components.tn.moreNext') }}</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line prettier/prettier
import { 
  addSeconds, subSeconds, startOfMinute, startOfHour, 
  startOfDay, endOfDay, format, parseISO, 
  getSeconds, setSeconds, getMinutes, setMinutes, 
  isBefore, isAfter
} from 'date-fns';

export default {
  props: {
    value: {
      type: [Number, Date],
      required: false,
      default: () => new Date(),
    },
    interval: {
      type: Number,
      required: false,
      default: 1800,
    },
    backward: {
      type: Array,
      required: true,
    },
    forward: {
      type: Array,
      required: true,
    },
    increment: {
      type: Number,
      required: false,
      default: -1,
    },
    activeIncrement: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      return {
        'mr-auto': true,
        'd-flex ': true,
        'navigator-width': this.increment > -1 ? false : true,
        'navigator-full-width': this.increment > -1 ? true : false,
      };
    },
  },
  data() {
    return {
      date: null,
      time: null,
      datepicker: false,
      timetables: [],
      // autoIncrement: this.increment > 0,
      incrementSchedulerId: null,
      disabledForward: true,
      disabledFurtherForward: true,
      disabledForwardSchedulerId: null,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.setDateTime(value, false);
      },
    },
    activeIncrement: {
      handler(value) {
        this.toggleAutoIncrement(value);
      },
    },
  },
  created() {
    // timetables
    let start = startOfDay(new Date());
    const end = subSeconds(endOfDay(new Date()), this.interval);
    while (isBefore(start, end)) {
      start = addSeconds(start, this.interval);
      this.timetables.push(format(start, 'HH:mm:ss'));
    }
    if (this.activeIncrement) {
      this.startIncrementScheduler();
    } else {
      this.startDisabledForwardScheduler();
    }
  },
  beforeDestroy() {
    clearInterval(this.incrementSchedulerId);
    clearInterval(this.disabledForwardSchedulerId);
  },
  methods: {
    canMoveForward(seconds) {
      if (this.activeIncrement) {
        return true;
      }
      return isAfter(new Date(), addSeconds(this.getDateTime(), seconds));
    },
    moveBackward(seconds) {
      this.emitActiveIncrement(false);
      this.setDateTime(subSeconds(this.getDateTime(), seconds));
    },
    moveForward(seconds) {
      this.emitActiveIncrement(false);
      this.setDateTime(addSeconds(this.getDateTime(), seconds));
    },
    getDateTime() {
      return parseISO(this.date + 'T' + this.time);
    },
    setDateTime(datetime, emit = true) {
      this.date = format(datetime, 'yyyy-MM-dd');
      this.time = format(datetime, 'HH:mm:ss');
      if (emit) {
        this.$emit('input', datetime);
        this.$emit('change', datetime);
      }
    },
    setToday() {
      const today = format(new Date(), 'yyyy-MM-dd');
      if (this.date !== today) {
        this.emitActiveIncrement(false);
        this.date = today;
        this.setDateTime(this.getDateTime());
      }
    },
    setDate(date) {
      if (this.date !== date) {
        this.emitActiveIncrement(false);
        this.date = date;
        this.setDateTime(this.getDateTime());
      }
    },
    setTime(time) {
      if (this.time !== time) {
        this.emitActiveIncrement(false);
        this.time = time;
        this.setDateTime(this.getDateTime());
      }
    },
    startIncrementScheduler() {
      if (this.increment <= 60) {
        let seconds = getSeconds(this.value);
        seconds = seconds - (seconds % this.increment);
        this.setDateTime(setSeconds(this.value, seconds), false);
      } else if (this.increment >= 60 && this.increment <= 3600) {
        let minutes = getMinutes(this.value);
        minutes = minutes - (minutes % (this.increment / 60));
        this.setDateTime(startOfMinute(setMinutes(this.value, minutes)), false);
      } else {
        this.setDateTime(startOfHour(this.value), false);
      }

      if (!this.incrementSchedulerId) {
        this.incrementSchedulerId = setInterval(() => {
          this.setDateTime(addSeconds(this.getDateTime(), this.increment));
        }, this.increment * 1000);
      }
      this.stopDisabledForwardScheduler();
    },
    stopIncrementScheduler() {
      if (this.incrementSchedulerId) {
        clearInterval(this.incrementSchedulerId);
        this.incrementSchedulerId = null;
      }
      this.startDisabledForwardScheduler();
    },
    startDisabledForwardScheduler() {
      if (!this.disabledForwardSchedulerId) {
        this.disabledForwardSchedulerId = setInterval(() => {
          this.disabledForward = !this.canMoveForward(this.forward[0]);
          this.disabledFurtherForward = !this.canMoveForward(this.forward[1]);
        }, 300);
      }
    },
    stopDisabledForwardScheduler() {
      if (this.disabledForwardSchedulerId) {
        clearInterval(this.disabledForwardSchedulerId);
        this.disabledForwardSchedulerId = null;
      }
      this.disabledForward = true;
      this.disabledFurtherForward = true;
    },
    toggleAutoIncrement(obj) {
      if (this.increment > 0) {
        this.activeIncrement = obj instanceof Event ? !this.activeIncrement : obj;
        if (this.activeIncrement) {
          this.startIncrementScheduler();
        } else {
          this.stopIncrementScheduler();
        }
      }
    },
    emitActiveIncrement(active) {
      this.$emit('update:activeIncrement', active);
    },
  },
};
</script>

<style lang="scss" scoped>
.navigator-width {
  max-width: 376px;
}
.navigator-full-width {
  max-width: 408px;
}
.time-font {
  font-size: 11px !important;
}
.tooltip {
  font-size: 11px;
  padding: 3px 5px 3px 5px;
  opacity: 1 !important;
}
</style>
